<template>
  <div class="d-flex flex-wrap">
    <div v-for="(item, i) in arr" :key="i">
      <v-hover v-slot="{ hover }">
        <v-card class="ma-1" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" width="240">
          <div class="d-flex justify-center align-center pa-4">
            <video width="200" autoplay loop>
              <source :src="item.url" type="video/mp4" />
            </video>
          </div>
        </v-card>
      </v-hover>
    </div>
  </div>
</template>

<script>
const arr = [
  {
    url: "public/cdn/v1/assets/effects/texts/a.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/h.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/i.mp4",
  },

  {
    url: "public/cdn/v1/assets/effects/texts/d.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/e.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/f.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/g.mp4",
  },

  {
    url: "public/cdn/v1/assets/effects/texts/b.mp4",
  },
  {
    url: "public/cdn/v1/assets/effects/texts/c.mp4",
  },
];

export default {
  data() {
    return {
      arr: arr.map((item) => {
        return {
          url: item.url.replace("public", ""),
        };
      }),
    };
  },
};
</script>

<style></style>
